import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

// Shown in place of the court/trainer picker when the service has
// widgetAllowResourcePick off: the club assigns the resource, so the names are
// inventory the client still gets to see rather than options they can select.
// Never render these as disabled controls — greyed rows read as "unavailable".
function AssignedResourcePanel({ noun, names = [] }) {
  const isCourt = noun.toLowerCase() === "court";
  const plural = names.length === 1 ? noun.toLowerCase() : `${noun.toLowerCase()}s`;
  const lead = isCourt ? "You'll play on" : "You'll be matched with";
  const tail = isCourt ? "we pick the one that fits the schedule best" : "we pick the one who fits the schedule best";

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: "1.5px solid",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.28),
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05)
      }}
    >
      <Typography sx={{ fontSize: "0.8rem", color: "text.secondary", lineHeight: 1.45 }}>
        {names.length > 0
          ? `${lead} one of our ${names.length} ${plural} — ${tail}.`
          : `Your ${noun.toLowerCase()} is assigned automatically to keep the schedule tight.`}
      </Typography>

      {names.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1.25 }}>
          {names.map((name) => (
            <Chip
              key={name}
              label={name}
              size="small"
              sx={{
                height: "1.5rem",
                fontSize: "0.72rem",
                fontWeight: 600,
                bgcolor: "#fff",
                border: "1px solid",
                borderColor: "divider"
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

export function AssignedResourceNote({ noun }) {
  return (
    <Typography sx={{ mt: 1, px: 0.5, fontSize: "0.75rem", color: "text.secondary" }}>
      Your {noun.toLowerCase()} is assigned when the booking is confirmed.
    </Typography>
  );
}

export default AssignedResourcePanel;
